import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { JsontocsvService } from '../utility/services/jsontocsv.service';

@Component({
  selector: 'app-onlineedm',
  templateUrl: './onlineedm.component.html',
  styleUrls: ['./onlineedm.component.css']
})
export class OnlineedmComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource;
  data;
  constructor(private afs: AngularFirestore, private j2c: JsontocsvService) { }

  ngOnInit(): void {
    this.afs.collection('onlineedm').valueChanges().subscribe(res => {
      this.data = res;
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator =  this.paginator;
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  excel() {
    this.j2c.excel(this.data);
  }

}
